import React, { useState, useEffect } from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../assets/css/mainMenu.css";
import "../../assets/css/addunit.css";

import edit from "../../assets/icons/edit.svg";

import close from "../../assets/icons/close.svg";

import recyclebin from "../../assets/icons/recycle-bin2.svg";

import ArrowDown from "../../assets/icons2/ArrowDown.svg";
import ArrowUp from "../../assets/icons2/ArrowUp.svg";
import plus1 from "../../assets/icons/plus1.svg";
import search2 from "../../assets/icons/search2.svg";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import { useNavigate } from "react-router-dom";
import fetchWrapper from "../../AuthMiddleware/FetchWrapper";
import Pagination from "../../Components/Pagination/Pagination";
import { hasPermission } from "../../Services/authUtils";
const User = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [users, setUsers] = useState([]);
	const [showAddModal, setShowAddModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [isDropdownOpen, setDropdownOpen] = useState(false);
	const [roles, setRoles] = useState([]);
	const [departments, setDepartments] = useState([]);
	const [confirmModal, setConfirmModal] = useState(false);
	const [actionType, setActionType] = useState(null);
	const [actionUserId, setActionUserId] = useState(null);
	const [selectedUser, setSelectedUser] = useState({
		name: "",
		username: "",
		email: "",
		mobile_no: "",
		role_id: "",
		department_id: "",
	});
	const [statusFilter, setStatusFilter] = useState("");

	const [newUser, setNewUser] = useState({
		name: "",
		username: "",
		email: "",
		mobile_no: "",
		role_id: "",
		department_id: "",
	});

	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortBy, setSortBy] = useState({
		field: "name",
		order: "asc",
	});
	const [search, setSearch] = useState("");
	const [totalPages, setTotalPages] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);
	const [totalItems, setTotalItems] = useState(0);
	const [allChecked, setAllChecked] = useState(false);
	const [checkedItems, setCheckedItems] = useState([]);
	const [bulkDeleteModal, setBulkDeleteModal] = useState(false);
	const [errors, setErrors] = useState({});
	const startIndex = (page - 1) * pageSize + 1;
	const endIndex = Math.min(page * pageSize, totalItems);

	const fetchUsers = async () => {
		const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}&status=${statusFilter}`;
		const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/user/pagination${queryString}`;

		try {
			const data = await fetchWrapper(
				url,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
				},
				navigate // Pass navigate here
			);

			setUsers(data.users || []);
			setTotalPages(data.totalPages);
			setCurrentPage(data.currentPage);
			setTotalItems(data.totalItems);

		} catch (error) {
			console.error("Error fetching users:", error);
		}
	};
	const fetchRoles = async () => {
		try {
			const data = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/role/getall`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
				},
				navigate // Pass navigate here
			);


			if (Array.isArray(data.roles)) {
				setRoles(data.roles);
			} else {
				throw new Error("Roles data is not an array");
			}
		} catch (error) {
			console.error(error);
			setRoles([]);
		}
	};
	const fetchDepartments = async () => {
		try {
			const data = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/department/getall`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
				},
				navigate // Pass navigate here
			);

			setDepartments(data.departments);
		} catch (error) {
			console.error(error);
		}
	};

	const handleAddUser = async (e) => {
		e.preventDefault();
		setLoading(true);
		setErrors({});

		// Log the newUser data before sending it


		try {
			// Send a POST request to the server to add a new user
			const data = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/user/create`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(newUser),
				},
				navigate // Pass navigate here if needed
			);

			setLoading(false);
			setUsers((prevUsers) => [...prevUsers, data.user]);


			setShowAddModal(false); // Close the add modal
			setNewUser({
				// Reset newUser state to empty fields
				name: "",
				username: "",
				email: "",
				mobile_no: "",
				role_id: "",
				department_id: "",
				password: "",
			});
			toast.success("User added successfully");

			fetchUsers(); // Fetch updated users
		} catch (error) {
			setLoading(false); // Ensure loading state is reset in case of an error
			if (error.response) {
				const errorData = error.response;
				console.error(errorData);
				setErrors(errorData.errors || {});
				toast.error(errorData.message || "Error adding user");
			} else {
				console.error(error);
				toast.error("Error adding user");
			}
		}
	};

	const userData = sessionStorage.getItem("user");
	const confirmAction = async () => {
		setLoading(true);
		if (userData) {
			const user = JSON.parse(userData);

			const userId = user._id;
			if (userId === actionUserId) {
				toast.error("Cannot perform an inactive action on your own account.");
				setLoading(false);
				setConfirmModal(false);
				return;
			}


		}

		try {
			const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/user/delete/${actionUserId}`;

			// Send a POST request to the server to perform the action on the user
			await fetchWrapper(
				url,
				{
					method: "POST",
				},
				navigate
			);

			setLoading(false);

			// Update the user's status locally
			const updatedUsers = users.map((user) =>
				user._id === actionUserId
					? { ...user, status: actionType === "Inactive" ? false : true }
					: user
			);
			setUsers(updatedUsers);
			setConfirmModal(false);

			if (actionType === "Inactive") {
				toast.success("User Inactive Successful");
			} else {
				toast.success("User Restore Successful");
			}
		} catch (error) {
			setLoading(false);
			console.error(`Error ${actionType} user:`, error);
			toast.error(`Error ${actionType} user`);
		}
	};

	const handleBulkDelete = async () => {
		setLoading(true);

		try {
			const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/user/delete/${checkedItems[0]}`;

			// Send a POST request to delete multiple users
			await fetchWrapper(
				url,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						ids: checkedItems,
					}),
				},
				navigate
			);

			setLoading(false);

			// Update the users' status locally
			const updatedUsers = users.map((user) =>
				checkedItems.includes(user._id) ? { ...user, status: false } : user
			);
			setUsers(updatedUsers);
			setBulkDeleteModal(false);
			toast.success(`All the selected items are Inactivated successfully`);
			setAllChecked(false);
			setCheckedItems([]);
		} catch (error) {
			setLoading(false);
			console.error(`Error deleting selected users:`, error);
			toast.error(`Error deleting selected users`);
		}
	};

	const handleUpdateUser = async (e) => {
		e.preventDefault();
		setLoading(true);

		try {
			// Send a POST request to update a user
			const data = await fetchWrapper(
				`${process.env.REACT_APP_BASE_API_URL1}/api/v1/user/update/${selectedUser._id}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(selectedUser),
				},
				navigate // Pass navigate here
			);

			const updatedUsers = users.map((user) =>
				user._id === selectedUser._id ? data.user : user
			);

			setLoading(false);
			setUsers(updatedUsers);
			setShowEditModal(false);
			toast.success("User updated successfully");
		} catch (error) {
			setLoading(false); // Ensure loading state is reset in case of an error
			if (error.response) {
				const errorData = error.response;
				console.error(errorData);
				setErrors(errorData.errors || {});
				toast.error(errorData.message || "Error updating user");
			} else {
				console.error(error);
				toast.error("Error updating user");
			}
		}
	};

	const handleToggleUserStatus = (userId, currentStatus) => {
		// Set the action type based on current status
		setActionType(currentStatus ? "Inactive" : "Restore");
		setActionUserId(userId);
		setConfirmModal(true);
	};

	const handleSearchChange = (event) => {
		setSearch(event.target.value);
		setPage(1);
	};

	const toggleDropdown = () => {
		setDropdownOpen(!isDropdownOpen);
	};

	const handlePageChange = (page) => {
		if (page >= 1 && page <= totalPages) {
			setCurrentPage(page);
			setPage(page);
			// Add any additional logic for page change here
		}
	};

	const handleInputChange = (e) => {
		const { value } = e.target;
		// Allow only numeric values
		if (/^\d*$/.test(value)) {
			setNewUser({
				...newUser,
				mobile_no: value,
			});
		}
	};

	// Calculate the page numbers to display

	const handlePageSizeChange = (size) => {
		setPageSize(size);
		setPage(1);
	};

	const handleSortChange = (field) => {
		setSortBy((prevSort) => ({
			field,
			order:
				prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
		}));
	};
	const handleStatusChange = (status) => {
		setStatusFilter(status === "all" ? "" : status);
		setPage(1); // Reset to the first page when changing status
	};

	const handleHeaderCheckboxChange = () => {
		const newCheckedStatus = !allChecked;
		setAllChecked(newCheckedStatus);
		if (newCheckedStatus) {
			setCheckedItems(
				users.filter((user) => user.status).map((user) => user._id)
			);
		} else {
			setCheckedItems([]);
		}
	};

	const handleRowCheckboxChange = (userId) => {
		setCheckedItems((prevCheckedItems) => {
			const isChecked = prevCheckedItems.includes(userId);
			const updatedCheckedItems = isChecked
				? prevCheckedItems.filter((id) => id !== userId)
				: [...prevCheckedItems, userId];

			setAllChecked(
				updatedCheckedItems.length ===
				users.filter((user) => user.status).length
			);
			return updatedCheckedItems;
		});
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			e.preventDefault(); // Prevent default behavior if needed
			fetchUsers(); // Perform search
		}
	};
	useEffect(() => {
		// fetchData();
		fetchUsers();
		fetchRoles();
		fetchDepartments();
	}, [
		// users.length,
		// roles.length,
		// departments.length,

		showEditModal,
		statusFilter,
		page,
		pageSize,
		sortBy,
		// search,
		// totalPages,
		// currentPage,
		// totalItems,
	]);

	return (
		<>
			<div className="">
				<div className="container">
					<div className="show-breadcrumb pt-3 ">
						<div className="d-flex">
							{" "}
							<h5 className="">Users</h5>
						</div>

						<nav className="breadcrumb-nav">
							<ol className="breadcrumb ">
								<li className="breadcrumb-item ">
									<a className="">Configure</a>
								</li>
								<li className="breadcrumb-item">
									<a className="">User Settings</a>
								</li>
								<li className="breadcrumb-item active" aria-current="page">
									Users
								</li>
							</ol>
						</nav>

						<div className="">
							<div
								className="navbar-3 d-flex justify-content-between"
								style={{ marginTop: "-3px" }}
							>
								<div className="d-flex gap-3">
									<div className="search-container ">
										<img src={search2} alt="Search" />
										<input
											type="text"
											className=""
											id="search"
											value={search}
											onChange={handleSearchChange}
											onKeyDown={handleKeyDown}
											placeholder="Search "
											name="search"
											autoComplete="off"
										/>
									</div>
									{hasPermission(["users.delete"]) && (
										<div>
											{checkedItems.length > 0 && (
												<button
													id="bulkDelete"
													className="bulkDelete-btn"
													style={{ display: "block" }}
													onClick={() => setBulkDeleteModal(true)}
												>
													<span>
														<img
															src={recyclebin}
															height="24px"
															width="24px"
															alt=""
														/>
													</span>{" "}
													Inactive
												</button>
											)}
										</div>
									)}
								</div>

								<div className="d-flex gap-3">
									<div className="dropdown">
										<select
											id="cars"
											className=" select-unit textarea"
											value={statusFilter}
											onChange={(e) => handleStatusChange(e.target.value)}
											style={{
												width: "120px",
												height: "calc(100% - 1px)",
											}}
										>
											<option value="">All</option>
											<option value="active">Active</option>
											<option value="inactive">Inactive</option>
										</select>
									</div>
									{hasPermission(["users.create"]) && (
										<div>
											<button
												type="button"
												id="openPopup"
												className="btn-bg"
												onClick={() => {
													setErrors({});
													setNewUser({
														name: "",
														username: "",
														email: "",
														mobile_no: "",
														role_id: "",
														department_id: "",
														password: "",
													});
													setShowAddModal(true);
												}}
											>
												<span className="plus-icon">
													<img src={plus1} alt="Plus Icon" />
												</span>
												Add User
											</button>
										</div>
									)}
								</div>
							</div>

							<div style={{ marginTop: "-10px" }}>
								<div className="table-responsive">
									<table className="table  align-middle table-text">
										<thead className="table-head align-middle">
											<tr>
												<th className="table-check">
													<input
														type="checkbox"
														checked={allChecked}
														onChange={handleHeaderCheckboxChange}
													/>
												</th>
												<th className="col">ID</th>

												<th onClick={() => handleSortChange("name")}>
													NAME{" "}
													{sortBy.field === "name" && (
														<span>
															{sortBy.order === "asc" ? (
																<img src={ArrowUp} alt="ArrowUp" />
															) : (
																<img src={ArrowDown} alt="ArrowDown" />
															)}
														</span>
													)}
												</th>
												<th onClick={() => handleSortChange("email")}>
													EMAIL{" "}
													{sortBy.field === "email" && (
														<span>
															{sortBy.order === "asc" ? (
																<img src={ArrowUp} alt="ArrowUp" />
															) : (
																<img src={ArrowDown} alt="ArrowDown" />
															)}
														</span>
													)}
												</th>
												<th onClick={() => handleSortChange("mobile_no")}>
													PHONE NO{" "}
													{sortBy.field === "mobile_no" && (
														<span>
															{sortBy.order === "asc" ? (
																<img src={ArrowUp} alt="ArrowUp" />
															) : (
																<img src={ArrowDown} alt="ArrowDown" />
															)}
														</span>
													)}
												</th>
												<th>
													{/* <th onClick={() => handleSortChange("role_id")}> */}
													ROLE{" "}
													{/* {sortBy.field === "role_id" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )} */}
												</th>
												<th>
													{/* <th onClick={() => handleSortChange("department_id")}> */}
													DEPARTMENT{" "}
													{/* {sortBy.field === "department_id" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )} */}
												</th>
												<th>STATUS</th>
												{(hasPermission(["users.update"]) ||
													hasPermission(["users.delete"])) && <th>ACTION</th>}
											</tr>
										</thead>
										<tbody>
											{users.map(
												(user, index) =>
													user && (
														<tr
															key={user._id}
															className={
																user.status ? "" : "disabled text-muted"
															}
														>
															<td className="table-check">
																<input
																	type="checkbox"
																	checked={checkedItems.includes(user._id)}
																	onChange={() =>
																		handleRowCheckboxChange(user._id)
																	}
																	disabled={!user.status}
																/>
															</td>
															<td>{index + startIndex}</td>
															<td>{user.name}</td>
															<td>{user.email}</td>
															<td>{user.mobile_no}</td>
															<td>
																{roles.length > 0
																	? roles.find(
																		(role) =>
																			role._id ===
																			(user.role_id && user.role_id)
																	)?.role_name || "N/A"
																	: "Loading..."}
															</td>
															<td>
																{departments.find(
																	(department) =>
																		department._id === user.department_id
																)?.department_name || "N/A"}
															</td>
															<td>
																{user.status ? (
																	<span className="active-status">Active</span>
																) : (
																	<span className="inactive">Inactive</span>
																)}
															</td>
															{(hasPermission(["users.update"]) ||
																hasPermission(["users.delete"])) && (
																	<td>
																		<div className="action-icons d-flex justify-content-left align-items-center ">
																			{user.status &&
																				hasPermission(["users.update"]) && (
																					<button
																						style={{
																							border: "none",
																							background: "transparent",
																						}}
																						className="align-content-center me-3"
																						onClick={() => {
																							setErrors({});
																							setSelectedUser(user);
																							setShowEditModal(true);
																						}}
																						disabled={!user.status}
																					>
																						<img src={edit} alt="edit" />
																					</button>
																				)}
																			{hasPermission(["users.delete"]) && (
																				<span className="align-content-center switcher">
																					<label className="switch switch1">
																						<input
																							type="checkbox"
																							checked={user.status}
																							onChange={() =>
																								handleToggleUserStatus(
																									user._id,
																									user.status
																								)
																							}
																						/>
																						<span className="slider slider1 round"></span>
																					</label>
																				</span>
																			)}
																		</div>
																	</td>
																)}
														</tr>
													)
											)}
										</tbody>
									</table>
								</div>
								<Pagination
									currentPage={currentPage}
									totalPages={totalPages}
									onPageChange={handlePageChange}
									pageSize={pageSize}
									onPageSizeChange={handlePageSizeChange}
									totalItems={totalItems}
									startIndex={startIndex}
									endIndex={endIndex}
								/>
							</div>
						</div>
					</div>
				</div>
				{/* Add Modal */}
				<div
					id="overlay"
					className={`modal fade ${showAddModal ? "show" : ""}`}
					tabIndex="-1"
					role="dialog"
					style={{
						zIndex: 30,
						display: showAddModal ? "block" : "none",
						transition: "width 2s",
					}}
				>
					{loading ? (
						<Loader />
					) : (
						<div className="addunit-card Width 25%">
							<div className="addunit-header">
								<h4>Add User</h4>
								<button
									style={{ border: "none", backgroundColor: "inherit" }}
									type="button"
									className="close"
									onClick={() => {
										setNewUser({
											name: "",
											username: "",
											email: "",
											mobile_no: "",
											role_id: "",
											department_id: "",
										});
										setShowAddModal(false);
									}}
								>
									<img src={close} width="28px" height="28px" alt="Close" />
								</button>
							</div>

							<form
								onSubmit={handleAddUser}
								autoComplete="off"
								noValidate
								className="needs-validation"
							>
								<div className="addunit-form">
									<div className="row mb-4">
										<div className="col-sm-12">
											<div className="d-flex flex-column">
												<label htmlFor="name" className="addunit-form-text">
													Name <span className="text-danger"> *</span>
												</label>
												<input
													type="text"
													className={`form-control ${errors.name ? "is-invalid" : ""
														}`}
													id="name"
													placeholder="Enter the Name"
													value={newUser.name}
													onChange={(e) =>
														setNewUser({ ...newUser, name: e.target.value })
													}
												/>
												{errors.name && (
													<div className="invalid-feedback">{errors.name}</div>
												)}
											</div>
										</div>
										{/*
                    <div className="col-sm-6">
                      <div className="d-flex flex-column">
                        <label htmlFor="email" className="addunit-form-text">
                          Username
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            errors.username ? "is-invalid" : ""
                          }`}
                          id="username"
                          placeholder="Enter the Username"
                          value={newUser.username}
                          onChange={(e) =>
                            setNewUser({ ...newUser, username: e.target.value })
                          }
                        />
                        {errors.username && (
                          <div className="invalid-feedback">
                            {errors.username}
                          </div>
                        )}
                      </div>
                    </div> */}
									</div>

									<div className="form-group ">
										<div className="row mb-4">
											<div className="col-sm-6">
												<div className="d-flex flex-column">
													<label htmlFor="email" className="addunit-form-text">
														Email Address{" "}
														<span className="text-danger"> *</span>
													</label>
													<input
														type="email"
														className={`form-control ${errors.email ? "is-invalid" : ""
															}`}
														id="email"
														placeholder="Enter the User Email"
														value={newUser.email}
														onChange={(e) =>
															setNewUser({ ...newUser, email: e.target.value })
														}
													/>
													{errors.email && (
														<div className="invalid-feedback">
															{errors.email}
														</div>
													)}
												</div>
											</div>
											<div className="col-sm-6">
												<div className="d-flex flex-column">
													<label
														htmlFor="password"
														className="addunit-form-text"
													>
														Password <span className="text-danger"> *</span>
													</label>
													<input
														type="password"
														className={`form-control ${errors.password ? "is-invalid" : ""
															}`}
														id="password"
														placeholder="Enter the User Password"
														value={newUser.password}
														onChange={(e) =>
															setNewUser({
																...newUser,
																password: e.target.value,
															})
														}
													/>
													{errors.password && (
														<div className="invalid-feedback">
															{errors.password}
														</div>
													)}
													<small className="mt-2 text-center">Password must be at least 8 characters long and include an uppercase letter, a lowercase letter, a number, and a special character</small>
												</div>
											</div>
										</div>

										<div className="row mb-4">
											<div className="col-sm-6">
												<div className="d-flex flex-column">
													<label
														htmlFor="mobile_no"
														className="addunit-form-text"
													>
														Phone Number <span className="text-danger"> *</span>
													</label>

													{/* <input
                            type="number"
                            className={`form-control ${
                              errors.mobile_no ? "is-invalid" : ""
                            }`}
                            placeholder="Enter the Mobile number"
                            id="mobile_no"
                            value={newUser.mobile_no}
                            onChange={(e) =>
                              setNewUser({
                                ...newUser,
                                mobile_no: e.target.value,
                              })
                            }
                          /> */}

													<input
														type="text"
														className={`form-control ${errors.mobile_no ? "is-invalid" : ""
															}`}
														placeholder="Enter the Mobile number"
														id="mobile_no"
														value={newUser.mobile_no}
														onChange={handleInputChange}
													/>

													{/*
                          <input
                            type="text"
                            className={`form-control ${
                              errors.mobile_no ? "is-invalid" : ""
                            }`}
                            placeholder="Enter the Mobile number"
                            id="mobile_no"
                            onKeyDown={handleKeyDown}
                            value={newUser.mobile_no}
                            onChange={(e) =>
                              setNewUser({
                                ...newUser,
                                mobile_no: e.target.value,
                              })
                            }
                          /> */}
													{/*
                           <input
            type="text"
            id="phone"
            value={newUser.mobile_no}
            onChange={(e) =>
              setNewUser({
                ...newUser,
                mobile_no: e.target.value,
              })}
            onKeyDown={handleKeyDown}
            placeholder="Enter your phone number"
          /> */}

													{errors.mobile_no && (
														<div className="invalid-feedback">
															{errors.mobile_no}
														</div>
													)}
												</div>
											</div>
										</div>
									</div>
									<div className="row mb-4">
										<div className="col col-6">
											<div className="d-flex flex-column col">
												<label htmlFor="role_id" className="addunit-form-text">
													Role <span className="text-danger"> *</span>
												</label>
												<select
													className={`form-select select-unit textarea ${errors.role_id ? "is-invalid" : ""
														}`}
													id="role_id"
													value={newUser.role_id}
													onChange={(e) =>
														setNewUser({ ...newUser, role_id: e.target.value })
													}
												>
													<option value="">Select Role</option>
													{roles.map((role) => (
														<option key={role._id} value={role._id}>
															{role.role_name}
														</option>
													))}
												</select>
												{errors.role_id && (
													<div className="invalid-feedback">
														{errors.role_id}
													</div>
												)}
											</div>
										</div>
										<div className="col col-6">
											<div className="d-flex flex-column  col">
												<label
													htmlFor="department_id"
													className="addunit-form-text"
												>
													Department <span className="text-danger"> *</span>
												</label>
												<select
													className={`form-select select-unit textarea ${errors.department_id ? "is-invalid" : ""
														}`}
													id="department_id"
													value={newUser.department_id}
													onChange={(e) =>
														setNewUser({
															...newUser,
															department_id: e.target.value,
														})
													}
												>
													<option value="">Select Department</option>
													{departments.map((department) => (
														<option key={department._id} value={department._id}>
															{department.department_name}
														</option>
													))}
												</select>
												{errors.department_id && (
													<div className="invalid-feedback">
														{errors.department_id}
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
								<div className="addunit-card-footer justify-content-between">
									<button
										type="button"
										className="discard-btn"
										onClick={() => {
											setNewUser({
												name: "",
												username: "",
												email: "",
												mobile_no: "",
												role_id: "",
												department_id: "",
											});
											setShowAddModal(false);
										}}
									>
										Close
									</button>
									<button type="submit" className="update-btn">
										Add
									</button>
								</div>
							</form>
						</div>
					)}
				</div>

				{/* Edit Modal */}
				<div
					id="overlay"
					className={`modal fade ${showEditModal ? "show" : ""}`}
					tabIndex="-1"
					role="dialog"
					style={{
						zIndex: 30,
						display: showEditModal ? "block" : "none",
						transition: "width 2s",
					}}
				>
					{loading ? (
						<Loader />
					) : (
						<div>
							<div className="addunit-card Width 25%">
								<div className="addunit-header">
									<h4>Edit User</h4>
									<button
										style={{ border: "none", backgroundColor: "inherit" }}
										type="button"
										className="close"
										onClick={() => {
											setNewUser({
												// Reset newUser state to empty fields
												name: "",
												username: "",
												email: "",
												mobile_no: "",
												role_id: "",
												department_id: "",
												password: "",
											});
											setShowEditModal(false);
										}}
									>
										<img src={close} width="28px" height="28px" alt="Close" />
									</button>
								</div>

								<form
									onSubmit={handleUpdateUser}
									noValidate
									autoComplete="off"
									className="needs-validation"
								>
									{selectedUser && ( // Add this condition
										<div className="addunit-form">
											<div className="row mb-4">
												<div className="col-sm-12">
													<div className="d-flex flex-column">
														<label
															htmlFor="editName"
															className="addunit-form-text"
														>
															Name <span className="text-danger"> *</span>
														</label>
														<input
															type="text"
															className={`form-control ${errors.name ? "is-invalid" : ""
																}`}
															placeholder="Enter the User Name"
															id="editName"
															value={selectedUser.name}
															onChange={(e) =>
																setSelectedUser({
																	...selectedUser,
																	name: e.target.value,
																})
															}
														/>
														{errors.name && (
															<div className="invalid-feedback">
																{errors.name}
															</div>
														)}
													</div>
												</div>

												{/* <div className="col-sm-6">
                          <div className="d-flex flex-column">
                            <label
                              htmlFor="editName"
                              className="addunit-form-text"
                            >
                              Username
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                errors.username ? "is-invalid" : ""
                              }`}
                              placeholder="Enter the User Name"
                              id="editUsername"
                              value={selectedUser.username}
                              onChange={(e) =>
                                setSelectedUser({
                                  ...selectedUser,
                                  username: e.target.value,
                                })
                              }
                            />
                            {errors.username && (
                              <div className="invalid-feedback">
                                {errors.username}
                              </div>
                            )}
                          </div>
                        </div> */}
											</div>

											<div className="form-group row mb-4">
												<div className="col-sm-6">
													<div className="d-flex flex-column">
														<label
															htmlFor="editEmail"
															className="addunit-form-text"
														>
															Email Address{" "}
															<span className="text-danger"> *</span>
														</label>
														<input
															type="email"
															className={`form-control ${errors.email ? "is-invalid" : ""
																}`}
															placeholder="Enter the Email Address"
															id="editEmail"
															value={selectedUser.email}
															onChange={(e) =>
																setSelectedUser({
																	...selectedUser,
																	email: e.target.value,
																})
															}
														/>
														{errors.email && (
															<div className="invalid-feedback">
																{errors.email}
															</div>
														)}
													</div>
												</div>

												<div className="col-sm-6">
													<div className="d-flex flex-column">
														<label
															htmlFor="editMobileNo"
															className="addunit-form-text"
														>
															Phone Number{" "}
															<span className="text-danger"> *</span>
														</label>
														<input
															type="text"
															className={`form-control ${errors.mobile_no ? "is-invalid" : ""
																}`}
															placeholder="Enter the Phone Number"
															id="editMobileNo"
															value={selectedUser.mobile_no}
															onChange={(e) =>
																setSelectedUser({
																	...selectedUser,
																	mobile_no: e.target.value,
																})
															}
														/>
														{errors.mobile_no && (
															<div className="invalid-feedback">
																{errors.mobile_no}
															</div>
														)}
													</div>
												</div>
											</div>

											<div className="row">
												<div className="d-flex flex-column col mb-4">
													<label
														htmlFor="editRole"
														className="addunit-form-text"
													>
														Role <span className="text-danger"> *</span>
													</label>
													<select
														className={`form-select select-unit textarea ${errors.role_id ? "is-invalid" : ""
															}`}
														id="editRole"
														value={selectedUser?.role_id}
														onChange={(e) =>
															setSelectedUser({
																...selectedUser,
																role_id: e.target.value,
															})
														}
													>
														<option value="">Select Role</option>
														{roles.map((role) => (
															<option key={role._id} value={role._id}>
																{role.role_name}
															</option>
														))}
													</select>
													{errors.role_id && (
														<div className="invalid-feedback">
															{errors.role_id}
														</div>
													)}
												</div>
											</div>

											<div className="row">
												<div className="d-flex flex-column col mb-4">
													<label
														htmlFor="editDepartment"
														className="addunit-form-text"
													>
														Department <span className="text-danger"> *</span>
													</label>
													<select
														className={`form-select select-unit textarea ${errors.department_id ? "is-invalid" : ""
															}`}
														id="editDepartment"
														value={selectedUser?.department_id}
														onChange={(e) =>
															setSelectedUser({
																...selectedUser,
																department_id: e.target.value,
															})
														}
													>
														<option value="">Select Department</option>
														{departments.map((department) => (
															<option
																key={department._id}
																value={department._id}
															>
																{department.department_name}
															</option>
														))}
													</select>
													{errors.department_id && (
														<div className="invalid-feedback">
															{errors.department_id}
														</div>
													)}
												</div>
											</div>
										</div>
									)}

									<div className="addunit-card-footer">
										<button
											type="button"
											className="discard-btn"
											onClick={() => setShowEditModal(false)}
										>
											Close
										</button>
										<button type="submit" className="update-btn">
											Save Changes
										</button>
									</div>
								</form>
							</div>
						</div>
					)}
				</div>

				{/* Confirmation Modal */}
				<div
					id="overlay"
					className={`modal fade ${confirmModal ? "show" : ""}`}
					tabIndex="-1"
					role="dialog"
					style={{
						zIndex: 30,
						display: confirmModal ? "block" : "none",
						transition: "width 2s",
					}}
				>
					{loading ? (
						<Loader />
					) : (
						<div>
							<div className="addunit-card Width 25%">
								<div className="addunit-header">
									<h4>
										{actionType === "Restore" ? "Restore" : "Inactivate"} User
									</h4>
									<button
										style={{ border: "none", backgroundColor: "inherit" }}
										type="button"
										className="close"
										onClick={() => setConfirmModal(false)}
									>
										<img src={close} width="28px" height="28px" alt="Close" />
									</button>
								</div>
								<div className="addunit-form">
									<p>
										Are you sure you want to{" "}
										{actionType === "Restore" ? "restore" : "inactivate"} this
										user?
									</p>
								</div>
								<div className="addunit-card-footer justify-content-between">
									<button
										type="button"
										className="discard-btn"
										onClick={() => setConfirmModal(false)}
									>
										Cancel
									</button>
									<button
										type="button"
										className="update-btn"
										onClick={confirmAction}
									>
										{actionType === "Restore" ? "Restore" : "Inactivate"}
									</button>
								</div>
							</div>
						</div>
					)}
				</div>

				{/* Bulk Delete Modal */}
				<div
					id="overlay"
					className={`modal fade ${bulkDeleteModal ? "show" : ""}`}
					tabIndex="-1"
					role="dialog"
					style={{
						zIndex: 30,
						display: bulkDeleteModal ? "block" : "none",
						transition: "width 2s",
					}}
				>
					{loading ? (
						<Loader />
					) : (
						<div>
							<div className="addunit-card Width 25%">
								<div className="addunit-header">
									<h4>Bulk Inactive</h4>
									<button
										style={{ border: "none", backgroundColor: "inherit" }}
										type="button"
										className="close"
										onClick={() => setBulkDeleteModal(false)}
									>
										<img src={close} width="28px" height="28px" alt="Close" />
									</button>
								</div>
								<div className="bulk-delete-unit">
									<img src={recyclebin} width="48px" height="48px" />

									<h4 className="delete-unit-h4">Inactive Users</h4>
									<p className="delete-unit-text">
										Are you sure you want to inactive all the selected users?
									</p>
								</div>
								<div className="addunit-card-footer justify-content-between">
									<button
										type="button"
										className="discard-btn"
										onClick={() => setBulkDeleteModal(false)}
									>
										CANCEL
									</button>
									<button
										type="button"
										className="update-btn"
										onClick={handleBulkDelete}
									>
										CONFIRM
									</button>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>

			<ToastContainer autoClose={2000} position={"top-right"} />
		</>
	);
};

export default User;
